import { prompt, type PromptDefinition } from './models';

export const PROPERTY_VALUER_PROMPTS = [
    prompt(
        'Assess value & use',
        'What areas, uses and occupancy details are documented for this building?',
        'Which buildings have inconsistent area, use or occupancy records?'
    ),
    prompt(
        'Assess value & use',
        'What condition issues in this building could warrant valuation review?',
        'Which buildings have condition issues to prioritise for valuation review?'
    ),
    prompt(
        'Assess value & use',
        'Which valuation-supporting documents are missing for this building?',
        'Where are the largest valuation-document gaps across my buildings?'
    ),
    prompt(
        'Assess value & use',
        'Find valuation evidence for this building relating to…',
        'Find valuation evidence across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Assess value & use',
        "What do this building's records say about recent improvements?",
        'Compare documented improvements across buildings being valued.'
    ),
    prompt(
        'Meet obligations',
        'What use restrictions are recorded for this building?',
        'Which buildings have recorded use restrictions relevant to valuation?'
    ),
    prompt(
        'Assess value & use',
        "What tenancy and lease details are available for this building's valuation?",
        'Compare available tenancy and lease evidence across buildings being valued.'
    ),
    prompt(
        'Assess value & use',
        'Find measured-area records for this building showing…',
        'Find measured-area records across my buildings showing…',
        'prefill'
    ),
    prompt(
        'Assess value & use',
        "How current are the reports supporting this building's valuation?",
        'Which buildings rely on the oldest valuation-supporting reports?'
    ),
    prompt(
        'Keep it running',
        "What replacement or capital works are identified in this building's reports?",
        'Which buildings have documented capital works relevant to valuation review?'
    ),
    prompt(
        'Assess value & use',
        'Which source records for this building disagree and need clarification?',
        'Which buildings have conflicting records that could affect valuation inputs?'
    ),
    prompt(
        'Assess value & use',
        'Compare the valuation assumptions for this building about…',
        'Compare valuation assumptions across my buildings about…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
